import { defineMessages } from "react-intl";

export const messagesContent = defineMessages({
  formEntityExistsError: {
    defaultMessage: '"{name}" already exists!',
  },
  formBasicError: {
    defaultMessage: 'Error. Cannot add "{name}".',
  },
});
